import { CONSTANTS } from '../../constants/constants';

const { CHARACTER_TO_REMOVE_POPOVERID } = CONSTANTS;
export function removeSpecialCharacters(inputString = ``): string {
	const regex = new RegExp(`[${CHARACTER_TO_REMOVE_POPOVERID}]`, `g`);
	const stringWithDashes = inputString.replace(/ /g, `-`);
	return stringWithDashes.replace(regex, ``);
}
